import React, {memo} from 'react';
import {ControlModel} from '../../../types/control';
import {Column} from '../../Column';
import {Widget} from '../../Widget';
import './index.scss';
import minusIcon from '../../../assets/images/icons/controls/minus.png';
import plusIcon from '../../../assets/images/icons/controls/plus.png';
import {onClickHandler} from '../../../utils/onclick';

type Props = {
    icon: string;
    control: ControlModel;
    homeValueTemperature: string;
    valueTemperature: string;
    click: () => void;
    temperatureClick: (isPlus: boolean) => void;
};

export const TemperatureControlComponent = memo(function TemperatureControlComponent({icon, control, valueTemperature, homeValueTemperature, click, temperatureClick}: Props) {
    return (
        <Column min={6} max={12}>
            <Widget style={{padding: 0}}>
                <div className="temperature-wrapper">
                    <img {...onClickHandler(click)} src={icon} alt='img'/>
                    <span>{control.name}</span>
                    <div className="temperature-content">
                        <span className="set-value-temperature">
                            {homeValueTemperature}<small>°</small>
                        </span>
                        <span className="home-value-temperature">
                            {valueTemperature}<small>°</small>
                        </span>
                    </div>
                    <div className="control-button-wrapper">
                        <div className="control-button">
                            <button {...onClickHandler(() => temperatureClick(false))}>
                                <img src={minusIcon} alt='minus'/>
                            </button>
                        </div>
                        <div className="control-button">
                            <button {...onClickHandler(() => temperatureClick(true))}>
                                <img src={plusIcon} alt='plus'/>
                            </button>
                        </div>
                    </div>
                </div>
            </Widget>
        </Column>
    );
});
